import NBType, { InferType } from '@netbase/nb-type'
import ThemeInfoSchema from './ThemeInfoSchema'

const ThemeInfoListSchema = NBType.object().shape('ThemeInfoListSchema', {
  /* @prop */
  id: NBType.number().notRequired(),
  /* @prop */
  themeInfos: NBType.array().of(ThemeInfoSchema)
  /* END */
})
export default ThemeInfoListSchema
export type ThemeInfoList = InferType<typeof ThemeInfoListSchema>
// RESERVE BELOW
